import React from "react";

export const GRUPOS_PERMISSAO = [
  { id: "cliente", titulo: "Clientes" },
  { id: "revenda", titulo: "Revendas" },
  { id: "licenca", titulo: "Licenças" },
  { id: "relatorio", titulo: "Relatórios" },
  { id: "usuario", titulo: "Usuários" },
];

export const ACOES_PERMISSAO = [
  { id: "ver", titulo: "Ver" },
  { id: "editar", titulo: "Editar" },
  { id: "cadastrar", titulo: "Cadastrar" },
];

export function flagsPadrao(audiencia) {
  return GRUPOS_PERMISSAO
    .filter((g) => audiencia !== "revenda" || g.id !== "revenda")
    .flatMap((g) => ACOES_PERMISSAO.map((a) => `${g.id}.${a.id}`));
}

const PermissoesUsuario = ({ audiencia = "admin", value = [], onChange }) => {
  const grupos = GRUPOS_PERMISSAO.filter((g) => audiencia !== "revenda" || g.id !== "revenda");
  const marcadas = new Set(value || []);

  const toggle = (codigo) => {
    const next = new Set(marcadas);
    if (next.has(codigo)) next.delete(codigo);
    else next.add(codigo);
    onChange(Array.from(next));
  };

  return (
    <div className="md:col-span-2">
      <p className="block text-sm font-medium text-gray-700 dark:text-slate-200 mb-2">Permissões</p>
      <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-white/10">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500 dark:text-slate-400">
              <th className="px-3 py-2 font-medium">Módulo</th>
              {ACOES_PERMISSAO.map((a) => (
                <th key={a.id} className="px-3 py-2 font-medium">{a.titulo}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {grupos.map((g) => (
              <tr key={g.id} className="border-t border-gray-100 dark:border-white/10">
                <td className="px-3 py-2 text-gray-800 dark:text-slate-100">{g.titulo}</td>
                {ACOES_PERMISSAO.map((a) => {
                  const codigo = `${g.id}.${a.id}`;
                  return (
                    <td key={codigo} className="px-3 py-2">
                      <input
                        type="checkbox"
                        checked={marcadas.has(codigo)}
                        onChange={() => toggle(codigo)}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PermissoesUsuario;
